/**
 * Map Page – Mobile Portal
 *
 * Purpose: Map of mobile units, NamPost offices, ATMs (consistent with Ketchup Portal map API).
 * Location: mobile-portal/src/pages/MapPage.tsx
 */

import { useQuery } from '@tanstack/react-query';
import { mapAPI, type MapLocation } from '@smartpay/api-client/ketchup';
import { FieldMap } from '../components/map/FieldMap';

export default function MapPage() {
  const { data: mobileUnits = [], isLoading: unitsLoading } = useQuery({
    queryKey: ['map-locations-mobile-units'],
    queryFn: () => mapAPI.getAllLocations({ type: 'mobile_unit' }),
    retry: false,
    staleTime: 2 * 60 * 1000,
  });

  const { data: fixedLocations = [], isLoading: fixedLoading } = useQuery({
    queryKey: ['map-locations-fixed'],
    queryFn: () => mapAPI.getFixedLocations(),
    retry: false,
    staleTime: 2 * 60 * 1000,
  });

  const locations: MapLocation[] = [
    ...mobileUnits.map((loc) => ({
      ...loc,
      type: loc.type as MapLocation['type'],
      status: (loc.status ?? 'active') as MapLocation['status'],
    })),
    ...fixedLocations.map((loc) => ({
      ...loc,
      type: (loc.type === 'nampost-office' ? 'nampost-office' : loc.type === 'atm' ? 'atm' : loc.type) as MapLocation['type'],
      status: (loc.status ?? 'active') as MapLocation['status'],
    })),
  ];

  const isLoading = unitsLoading || fixedLoading;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Map</h1>
        <p className="text-muted-foreground">Mobile units, NamPost offices, and ATM coordinates</p>
      </div>

      {isLoading ? (
        <div className="rounded-xl border bg-card p-8 text-center text-muted-foreground">Loading map…</div>
      ) : (
        <FieldMap locations={locations} />
      )}
    </div>
  );
}
